module.exports = __webpack_public_path__ + "5144946d3cc93ed2ce8e4e52af45f275.png";